export default object =>
  Object.keys(object).reduce(
    (indices, key, index) => ({ ...indices, [key]: index }),
    {}
  );
